import type { SVGProps } from 'react'
const LineFileUpload = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M4 2h9.56L20 8.44V22H4zm13.44 6L14 4.56V8zM5.5 3.5v17h13v-11h-4.75c-.69 0-1.25-.56-1.25-1.25V3.5zm2.72 10.72 2.895-2.895a1.26 1.26 0 0 1 1.77 0l2.895 2.895-1.06 1.06-1.97-1.97V18h-1.5v-4.69l-1.97 1.97z"
			clipRule="evenodd"
		/>
	</svg>
)
export { LineFileUpload }
